import { UsersWithRelationshipsGetRequestParams } from "@lib/core";

export interface UserDefaultParams extends UsersWithRelationshipsGetRequestParams { }
export class UserDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "id.asc";
  }
}